import axios from 'axios'

const Axios = axios.create({
    baseURL: 'https://api-tbd-prog31jours.jw-solutions.fr/',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        // 'Authorization': `Bearer ${token}`,
      },
})

export default Axios